export default __webpack_public_path__ + "static/media/ai-boat-project-pcb-boat.8d39c3c0.png";